import React, { useState, useEffect } from "react";
import { Button, Card, Row, Table, Form, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
  Filter,
} from "react-bs-datatable"; // Import components from react-bs-datatable
import AccountCodeService from "../../../../services/AccountCodeService";

const ListAccountCode = () => {
  const [accountcodes, setAccountcodes] = useState([]);
  const [filteredData, setFilteredData] = useState([]); // State for filtered data
  const [isLoading, setIsLoading] = useState(true);
 
  const [searchText, setSearchText] = useState('');
  const fetchAccountcodes = async () => {
    try {
      const response = await AccountCodeService.list();
      setAccountcodes(response.data);
      setFilteredData(response.data); // Initialize filtered data
    } catch (error) {
      console.error("Failed to fetch account codes:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAccountcodes();
  }, []);

  useEffect(() => {
    // Filter data whenever the search text changes
    const filtered = accountcodes.filter(
      (accountcode) =>
        accountcode.accountName
          .toLowerCase()
          .includes(searchText.toLowerCase()) ||
        accountcode.accountNumber
          .toLowerCase()
          .includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchText, accountcodes]); // Dependencies include search text and account codes

  const handleDelete = async (id) => {
    try {
      await AccountCodeService.delete({ id: id });
      fetchAccountcodes();
    } catch (error) {
      console.error("Failed to delete account code:", error);
    }
  };

  // Define table columns
  const columns = [
    {
      prop: "projectRequired",
      title: "Project Required",
      cell: (row) => (row.projectRequired.toLowerCase() === "n" ? "No" : "Yes"),
    },
    { prop: "accountName", title: "Account Name" },
    { prop: "accountNumber", title: "Account Number" },
    { prop: "project", title: "Project" },
    { prop: "accountDescription", title: "Account Description" },
    { prop: "accountCategory", title: "Account Category" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            to={`/settings/account-code/edit/${row._id}`}
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-pencil"></i>
          </Link>
          <Link
            to={`/settings/account-code/view/${row._id}`}
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-eye"></i>
          </Link>
          <Button
            variant="danger"
            onClick={() => handleDelete(row._id)}
            className="btn btn-danger shadow btn-xs sharp me-1"
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  return (
    <Card>
      <div className="card-body">
        <Row className="mb-4">
        <h3>List of Account </h3>
        <Col>
        <Link
          to="/settings/account-code/add"
          className="d-flex justify-content-end mb-4"
        >
          <Button>Add Account Code</Button>
        </Link>
        </Col>
        
        </Row>

        {/* Wrap the table with DatatableWrapper */}
        <DatatableWrapper
          body={filteredData} // Use filtered data instead of accountcodes
          headers={columns}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 10, // Set the default number of rows per page
              options: [5, 10, 15, 20],
            },
          }}
        >
          {/* Pagination Options and Filter */}
          <div className="d-flex justify-content-between mb-3" >
            <Row>
            <Col className="d-flex flex-col justify-content-end align-items-end">
        <Form.Control
                type="text"
                placeholder="Search by Job Title"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              </Col>
             
            </Row>
            
          </div>

          {/* Table structure */}
          <Table responsive>
            <TableHeader />
            <TableBody />
          </Table>

         <Row> <Col className="d-flex flex-col justify-content-start align-items-end" >
              <PaginationOptions />
              </Col>
              <Col className="d-flex flex-col justify-content-end align-items-end" >
              <Pagination />
              </Col></Row>
        
        </DatatableWrapper>
      </div>
    </Card>
  );
};

export default ListAccountCode;
